import React from "react"

import styles from "./whatIs.module.css"

const WhatIs = () => {
  return (
    <section>
      <div className="wrapper">
        <p className={styles.reasons}>
          A Facio é um benefício corporativo <strong>moderno</strong> que ajuda
          colaboradores com dívidas, emergências ou que querem começar a poupar.
        </p>
      </div>
    </section>
  )
}

export default WhatIs
